import { render, staticRenderFns } from "./TestVideoPoll.vue?vue&type=template&id=71f0dd34&scoped=true&"
import script from "./TestVideoPoll.vue?vue&type=script&lang=js&"
export * from "./TestVideoPoll.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoPoll.vue?vue&type=style&index=0&id=71f0dd34&prod&lang=css&"
import style1 from "./TestVideoPoll.vue?vue&type=style&index=1&id=71f0dd34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0dd34",
  null
  
)

export default component.exports